import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const RejectReportModal = ({ 
  show, 
  isRejectSuccess, 
  rejectSuccessMessage, 
  comments, 
  handleCancel, 
  setComments, 
  handleRejectContinue 
}) => (
  <Modal
    show={show}
    onHide={handleCancel}
    backdrop="static"
    keyboard={false}
    dialogClassName='checkerModal'
  >
    <Modal.Header closeButton>
      <Modal.Title>Selected report will be returned</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {isRejectSuccess ? (
        <p>{rejectSuccessMessage}</p>
      ) : (
        <>
          <p>Please specify changes:</p>
          <Form.Group>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter comments here..."
              value={comments}
              onChange={(e) => setComments(e.target.value)}
            />
          </Form.Group>
        </>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
      {!isRejectSuccess && (
        <Button variant="primary" onClick={handleRejectContinue}>Reject</Button>
      )}
      {isRejectSuccess && (
        <Button variant="primary" onClick={() => window.location.reload()}>Close</Button>
      )}
    </Modal.Footer>
  </Modal>
);

export default RejectReportModal;
